module.exports = __webpack_public_path__ + "static/lucid-ui.20e88f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/lucid-ui.png
// module id = 851
// module chunks = 73261030922168